import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { StateData } from '../../../types/state-data';
import { CompanyRoleData } from '../../../types/company-role-data';
import { GzFormFieldWebComponent } from '../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../ui/gzInput/component/GzInputWebComponent';
import { GzDropdownWebComponent } from '../../../../ui/gzDropdown';
import { GzTextareaWebComponent } from '../../../../ui/gzInput';
import { GzInputFileWebComponent } from '../../../../ui/gzInputFile';
import { GzCheckboxWebComponent } from '../../../../ui/gzCheckbox';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { CompanyDetailsConstants } from '../../companyDetailsTab/CompanyDetailsConstants';
import { TemplateState } from '../../../../types/common/types';
import { CountryData } from '../../../types/country-data';
import { IndustryData } from '../../../types/industry-data';
import { RequiredValidator } from '../../../../ui/gzForm/validators/required.validator';
import { MinLengthValidator } from '../../../../ui/gzForm/validators/min-length.validator';
import { MaxLengthValidator } from '../../../../ui/gzForm/validators/max-length.validator';
import { RegexValidator } from '../../../../ui/gzForm/validators/regex.validator';
import { EmailValidator } from '../../../../ui/gzForm/validators/email.validator';
import { CompanyDetailsFormViewData } from '../types/CompanyDetailsFormViewData';
import { CompanyData } from '../../../types/company-data';
import { RemoteValidator } from '../../../../ui/gzForm/validators/remote.validator';
import { CompanyTypeData } from '../../../types/company-type-data';
import { CompanyCustomizationData } from '../../../types/company-customization-data';
import { User } from '../../../types/user';
import { CompanyType } from '../../../types/company-type';
import { WhitelistValidator } from '../../../../ui/gzForm/validators/whitelist.validator';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { TimezoneData } from '../../../types/timezone-data';
import { LanguageData } from '../../../types/language-data';
import { toggleVisibility } from '../../../../utils/htmlElement.utils';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { GzTitleWebComponent } from '../../../../ui/gzTitle';
import { SubscriptionType } from '../../../../license/types/SubscriptionType';
import { CustomFieldsFormWebComponent } from '../../customFieldsForm';
import {
  WEB_COMPONENT_CUSTOM_FIELDS_FORM,
  WEB_COMPONENT_MDR_CONTACT_DETAILS_SECTION,
} from '../../../../webcomponents.constants';
import { CompanyEditingRight } from '../../types/CompanyEditingRight';
import { GzLinkWebComponent } from '../../../../ui/gzLinkComponent';
import { htmlEncode } from '../../../../utils/escape.utils';
import { LicenseConstants } from '../../../../license/LicenseConstants';
import { GzInfoBoxWebComponent } from '../../../../ui/gzInfoBox';
import { translateFn } from '../../../../utils/translator.helper';
import { QuarantineActionEnabler } from '../../../../quarantine/computersAndVirtualMachines/helpers/quarantineActionsEnabler';
import { FormValidator } from '../../../../ui/gzForm/formField/types/form-validator';
import { ContactDetailsSectionWebComponent } from '../../mdrContactDetails/mdrContactDetailsSection';
import { isEmpty } from 'lodash';
import { convertCountryCodeToPrefix } from '../../../../ui/gzPhoneInput/utils/phone-codes';
import { MdrContactImportSourceValue } from '../../mdrContactDetails/common/types';
import { ProductServiceStatus } from 'apps/webcomponents/src/license/types/ProductServiceStatus';
import { GzTextWebComponent } from '../../../../ui/gzText';

export class CompanyDetailsFormView extends BaseWebComponentView {
  public formGroup!: FormGroup;
  public contactPersonFormGroup!: FormGroup;
  public mdrContactDetailsMonthlyFormGroup: FormGroup;
  public primaryAccountProfileFormGroup!: FormGroup;

  public states: StateData[];
  public companyRoles: CompanyRoleData[];
  public defaultLogoId: string;

  public editedCompanyData?: CompanyData;

  private context: CompanyActionContext;
  private loggedUser: User;
  private editingRight: CompanyEditingRight;
  private rootVisibilityTree: string;

  public isInit = false;

  public dom: {
    $wrapper: HTMLElement;

    $basicDetailsSubtitle: GzTitleWebComponent;

    $companyNameFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;

    $companyTypeFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

    $partnerHasToAddProductsToSwitchToCustomerNoticeContainer: GzInfoBoxWebComponent;

    $partnerHasManagedNetworksNoticeContainer: GzInfoBoxWebComponent;

    $partnerWillLoseResellAddonsToggleNoticeContainer: GzInfoBoxWebComponent;

    $partnerWillLoseMdrReportsAccessNoticeContainer: GzInfoBoxWebComponent;

    $customerToPartnerResellingNoticeContainer: GzInfoBoxWebComponent;

    $companyCustomizationFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

    $countryFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
    $stateFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

    $industryFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

    $managementPermissionsSubtitle: GzTitleWebComponent;
    $managementPermissionsSubtitleInfoCompany: GzTextWebComponent;
    $managementPermissionsSubtitleInfoPartner: GzTextWebComponent;

    $managementPermissionsFormSection: HTMLElement;
    $manageNetworksFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
    $canBeManagedByAboveFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
    $allowDownloadQuarantineByAboveFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
    $partnerHasRedactionActiveFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
    $partnerHasRedactionLink: GzLinkWebComponent;

    $companyHasProductsWarningContainer: GzInfoBoxWebComponent;

    $companyHasChildrenWarningContainer: GzInfoBoxWebComponent;

    $primaryAccountSubtitle: GzTitleWebComponent;
    $primaryAccountSubtitleInfo: GzTextWebComponent;
    $primaryAccountSubtitleDescription: GzTextWebComponent;
    $primaryAccountFormSection: HTMLElement;

    $primaryAccountFullNameFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $primaryAccountEmailFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $primaryAccountTimezoneFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
    $primaryAccountLanguageFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

    $contactDetailsSubtitle: GzTitleWebComponent;
    $contactDetailsFormSection: HTMLElement;

    $contactFullNameFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $contactEmailFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $contactRoleFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
    $contactRoleOtherFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $contactPhoneFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;

    $mdrContactDetailsSectionYearly: ContactDetailsSectionWebComponent;

    $mdrContactDetailsSubtitle: GzTitleWebComponent;
    $mdrContactDetailsFormSection: HTMLElement;

    $mdrContactDetailsImportFromGeneralInfoNotice: GzTextWebComponent;
    $mdrContactDetailsFullNameFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $mdrContactDetailsEmailVerificationNotice: GzTextWebComponent;
    $mdrContactDetailsEmailFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $mdrContactDetailsEmailVerificationCodeFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $mdrContactDetailsPhoneFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
    $mdrContactDetailsImportFromGeneralInfoButton: GzButtonWebComponent;
    $mdrContactDetailsVerifyEmailButton: GzButtonWebComponent;
    $mdrContactDetailsCannotChangeNotice: GzTextWebComponent;

    $securityTokenFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;

    $additionalDetailsSubtitle: GzTitleWebComponent;
    $additionalDetailsSubtitleInfo: GzTextWebComponent;

    $companyAddressFormField: GzFormFieldWebComponent<GzTextareaWebComponent, string>;
    $companyPhoneFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;

    $logoFormField: GzFormFieldWebComponent<GzInputFileWebComponent, FileList | null>;
    $logoFileIdFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;

    $logoImg: HTMLImageElement;
    $logoHint: GzTextWebComponent;
    $logoUploadButton: GzButtonWebComponent;
    $logoResetButton: GzButtonWebComponent;

    $customFieldsForm: CustomFieldsFormWebComponent;
  };

  private subscriptions: Subscription[] = [];

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#company-details-form-wrapper'),

      $basicDetailsSubtitle: this.shadow.querySelector('#basic-details-subtitle'),

      $companyNameFormField: this.shadow.querySelector('#company-name-form-field'),
      $companyCustomizationFormField: this.shadow.querySelector('#company-customization-form-field'),

      $companyTypeFormField: this.shadow.querySelector('#company-type-form-field'),

      $partnerHasToAddProductsToSwitchToCustomerNoticeContainer: this.shadow.querySelector(
        '#company-type-partner-has-to-add-products-to-switch-to-customer-notice-container'
      ),

      $partnerHasManagedNetworksNoticeContainer: this.shadow.querySelector(
        '#company-type-partner-has-managed-companies-notice-container'
      ),

      $partnerWillLoseResellAddonsToggleNoticeContainer: this.shadow.querySelector(
        '#company-type-partner-will-lose-resell-addons-notice-container'
      ),

      $partnerWillLoseMdrReportsAccessNoticeContainer: this.shadow.querySelector(
        '#company-type-partner-will-lose-mdr-reports-access-notice-container'
      ),

      $customerToPartnerResellingNoticeContainer: this.shadow.querySelector(
        '#company-type-customer-to-partner-reselling-notice-container'
      ),

      $countryFormField: this.shadow.querySelector('#country-form-field'),
      $stateFormField: this.shadow.querySelector('#state-form-field'),

      $industryFormField: this.shadow.querySelector('#industry-form-field'),

      $managementPermissionsSubtitle: this.shadow.querySelector('#management-permissions-subtitle'),
      $managementPermissionsSubtitleInfoCompany: this.shadow.querySelector(
        '#management-permissions-subtitle-info-company'
      ),
      $managementPermissionsSubtitleInfoPartner: this.shadow.querySelector(
        '#management-permissions-subtitle-info-partner'
      ),
      $managementPermissionsFormSection: this.shadow.querySelector('#management-permissions-form-section'),
      $manageNetworksFormField: this.shadow.querySelector('#manage-networks-form-field'),
      $canBeManagedByAboveFormField: this.shadow.querySelector('#can-be-managed-by-above-form-field'),
      $allowDownloadQuarantineByAboveFormField: this.shadow.querySelector('#can-be-downloaded-by-above-form-field'),
      $partnerHasRedactionActiveFormField: this.shadow.querySelector('#partner-has-redaction-active-form-field'),
      $partnerHasRedactionLink: this.shadow.querySelector('#partner-redaction-link'),

      $companyHasProductsWarningContainer: this.shadow.querySelector('#company-has-products-warning-container'),

      $companyHasChildrenWarningContainer: this.shadow.querySelector(
        '#company-type-partner-has-children-manage-network-disabled-notice-container'
      ),

      $primaryAccountSubtitle: this.shadow.querySelector('#primary-account-subtitle'),
      $primaryAccountSubtitleInfo: this.shadow.querySelector('#primary-account-subtitle-info'),
      $primaryAccountSubtitleDescription: this.shadow.querySelector('#primary-account-subtitle-description'),
      $primaryAccountFormSection: this.shadow.querySelector('#primary-account-form-section'),

      $primaryAccountFullNameFormField: this.shadow.querySelector('#primary-account-full-name-form-field'),
      $primaryAccountEmailFormField: this.shadow.querySelector('#primary-account-email-form-field'),
      $primaryAccountTimezoneFormField: this.shadow.querySelector('#primary-account-timezone-form-field'),
      $primaryAccountLanguageFormField: this.shadow.querySelector('#primary-account-language-form-field'),

      $contactDetailsSubtitle: this.shadow.querySelector('#contact-details-subtitle'),
      $contactDetailsFormSection: this.shadow.querySelector('#contact-details-form-section'),

      $contactFullNameFormField: this.shadow.querySelector('#contact-full-name-form-field'),
      $contactEmailFormField: this.shadow.querySelector('#contact-email-form-field'),
      $contactRoleFormField: this.shadow.querySelector('#contact-role-form-field'),
      $contactRoleOtherFormField: this.shadow.querySelector('#contact-role-other-form-field'),
      $contactPhoneFormField: this.shadow.querySelector('#contact-phone-form-field'),

      $mdrContactDetailsSectionYearly: this.shadow.querySelector(WEB_COMPONENT_MDR_CONTACT_DETAILS_SECTION),

      $mdrContactDetailsSubtitle: this.shadow.querySelector('#mdr-contact-details-subtitle'),
      $mdrContactDetailsFormSection: this.shadow.querySelector('#mdr-contact-details-form-section'),

      $mdrContactDetailsImportFromGeneralInfoNotice: this.shadow.querySelector(
        '#mdr-contact-import-from-general-info-notice'
      ),
      $mdrContactDetailsFullNameFormField: this.shadow.querySelector('#mdr-contact-full-name-form-field'),

      $mdrContactDetailsEmailVerificationNotice: this.shadow.querySelector('#mdr-contact-email-verification-notice'),
      $mdrContactDetailsEmailFormField: this.shadow.querySelector('#mdr-contact-email-form-field'),
      $mdrContactDetailsEmailVerificationCodeFormField: this.shadow.querySelector(
        '#mdr-contact-email-verification-code-form-field'
      ),
      $mdrContactDetailsVerifyEmailButton: this.shadow.querySelector('#mdr-contact-verify-email-button'),

      $mdrContactDetailsPhoneFormField: this.shadow.querySelector('#mdr-contact-phone-form-field'),
      $mdrContactDetailsImportFromGeneralInfoButton: this.shadow.querySelector(
        '#mdr-contact-import-from-general-info-button'
      ),

      $mdrContactDetailsCannotChangeNotice: this.shadow.querySelector('#mdr-contact-cannot-change-notice'),

      $additionalDetailsSubtitle: this.shadow.querySelector('#additional-details-subtitle'),
      $additionalDetailsSubtitleInfo: this.shadow.querySelector('#additional-details-subtitle-info'),

      $companyAddressFormField: this.shadow.querySelector('#company-address-form-field'),
      $companyPhoneFormField: this.shadow.querySelector('#company-phone-form-field'),

      $logoFormField: this.shadow.querySelector('#logo-form-field'),
      $logoFileIdFormField: this.shadow.querySelector('#logo-file-id-form-field'),

      $logoImg: this.shadow.querySelector('#logo-img'),
      $logoHint: this.shadow.querySelector('#logo-hint'),
      $logoUploadButton: this.shadow.querySelector('#logo-upload-button'),
      $logoResetButton: this.shadow.querySelector('#logo-reset-button'),

      $customFieldsForm: this.shadow.querySelector(WEB_COMPONENT_CUSTOM_FIELDS_FORM),

      $securityTokenFormField: this.shadow.querySelector('#security-token-form-field'),
    };

    this.setLoadingState();

    this.getTranslations();
    this.setTranslatedStrings();
    this.buildProductSwitchCustomerNoticeInfoBox();
    this.buildManagedNetworksNoticeInfoBox();
    this.buildResellAddonsNoticeInfoBox();
    this.buildMdrReportsAccessSwitchCustomerNoticeInfoBox();
    this.buildPartnerResellingNoticeInfoBox();
    this.buildCompanyHasChildrenInfoBox();
    this.buildCompanyHasProductsInfoBox();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$basicDetailsSubtitle.innerText = this.dependencies.translateFn('Basic company details');

    this.dom.$companyNameFormField.label = this.dependencies.translateFn('Company name');
    this.dom.$companyNameFormField.Input.placeholder = this.dependencies.translateFn('Enter the company name');

    this.dom.$companyTypeFormField.label = this.dependencies.translateFn('Company type');
    this.dom.$companyTypeFormField.Input.placeholder = this.dependencies.translateFn('Select the company type');

    this.dom.$companyCustomizationFormField.label = this.dependencies.translateFn('UI customization');
    this.dom.$companyCustomizationFormField.Input.placeholder =
      this.dependencies.translateFn('Select UI customization');

    this.dom.$countryFormField.label = this.dependencies.translateFn('Country');
    this.dom.$countryFormField.Input.placeholder = this.dependencies.translateFn('Select the country');
    this.dom.$countryFormField.Input.noResultsFound = this.commonStrings.noResultsFound;

    this.dom.$stateFormField.label = this.dependencies.translateFn('State');
    this.dom.$stateFormField.Input.placeholder = this.dependencies.translateFn('Select the state');

    this.dom.$industryFormField.label = this.dependencies.translateFn('Industry');
    this.dom.$industryFormField.Input.placeholder = this.dependencies.translateFn('Select industry');
    this.dom.$industryFormField.Input.noResultsFound = this.commonStrings.noResultsFound;

    // primary account
    this.dom.$primaryAccountSubtitle.innerText = this.dependencies.translateFn('Primary account');
    this.dom.$primaryAccountSubtitleInfo.innerText = this.dependencies.translateFn(
      'Add a primary user account for this company.'
    );
    this.dom.$primaryAccountSubtitleDescription.innerText = this.dependencies.translateFn(
      'Bitdefender Partners who can assist with security management, have access to the company`s GravityZone assets from their account.'
    );

    this.dom.$primaryAccountFullNameFormField.label = this.dependencies.translateFn('Full name');
    this.dom.$primaryAccountFullNameFormField.Input.placeholder =
      this.dependencies.translateFn('Enter the name and surname');

    this.dom.$primaryAccountEmailFormField.label = this.dependencies.translateFn('Email address');
    this.dom.$primaryAccountEmailFormField.Input.placeholder = this.dependencies.translateFn('Enter the email address');

    this.dom.$primaryAccountTimezoneFormField.label = this.dependencies.translateFn('Timezone');
    this.dom.$primaryAccountTimezoneFormField.Input.placeholder = this.dependencies.translateFn('Select the timezone');

    this.dom.$primaryAccountLanguageFormField.label = this.dependencies.translateFn('Language');
    this.dom.$primaryAccountLanguageFormField.Input.placeholder = this.dependencies.translateFn('Select the language');

    // contact details
    this.dom.$contactDetailsSubtitle.innerText = this.dependencies.translateFn('Contact Details for GravityZone');

    this.dom.$contactFullNameFormField.label = this.dependencies.translateFn('Full name');
    this.dom.$contactFullNameFormField.Input.placeholder = this.dependencies.translateFn('Enter the name and surname');

    this.dom.$contactEmailFormField.label = this.dependencies.translateFn('Email address');
    this.dom.$contactEmailFormField.Input.placeholder = this.dependencies.translateFn('Enter the email address');

    this.dom.$contactRoleFormField.label = this.dependencies.translateFn('Position');
    this.dom.$contactRoleFormField.Input.placeholder = this.dependencies.translateFn('Select the position');

    this.dom.$contactRoleOtherFormField.label = this.dependencies.translateFn('Enter position');
    this.dom.$contactRoleOtherFormField.Input.placeholder = this.dependencies.translateFn('Enter the position');

    this.dom.$contactPhoneFormField.label = this.dependencies.translateFn('Phone number');
    this.dom.$contactPhoneFormField.Input.placeholder = this.dependencies.translateFn('Enter the phone number');

    // mdr contact information
    this.dom.$mdrContactDetailsSubtitle.innerText = this.dependencies.translateFn('Contact Details for MDR');

    this.dom.$mdrContactDetailsImportFromGeneralInfoNotice.innerText = this.dependencies.translateFn(
      'You can import the contact information from the designated Gravityzone contact person.'
    );
    this.dom.$mdrContactDetailsImportFromGeneralInfoButton.innerText = this.dependencies.translateFn('Import');

    this.dom.$mdrContactDetailsFullNameFormField.label = this.dependencies.translateFn('Full name');
    this.dom.$mdrContactDetailsFullNameFormField.Input.placeholder =
      this.dependencies.translateFn('Enter the name and surname');

    this.dom.$mdrContactDetailsEmailVerificationNotice.innerText = this.dependencies.translateFn(
      'You need to validate the address by requesting a verification code and entering it below. The code is valid for 30 minutes.'
    );
    this.dom.$mdrContactDetailsEmailFormField.label = this.dependencies.translateFn('Email address');
    this.dom.$mdrContactDetailsEmailFormField.Input.placeholder =
      this.dependencies.translateFn('Enter the email address');
    this.dom.$mdrContactDetailsEmailVerificationCodeFormField.label =
      this.dependencies.translateFn('Verification code');
    this.dom.$mdrContactDetailsEmailVerificationCodeFormField.Input.placeholder =
      this.dependencies.translateFn('Enter the verification code');
    this.dom.$mdrContactDetailsVerifyEmailButton.innerText = this.dependencies.translateFn('Send verification code');

    this.dom.$mdrContactDetailsPhoneFormField.label = this.dependencies.translateFn('Phone number');
    this.dom.$mdrContactDetailsPhoneFormField.Input.placeholder =
      this.dependencies.translateFn('Enter the phone number');

    this.dom.$mdrContactDetailsCannotChangeNotice.innerText = this.dependencies.translateFn(
      'Please make sure the information is correct. Once saved, you will not be able to edit this information from GravityZone.'
    );

    // additional details
    this.dom.$additionalDetailsSubtitle.innerText = `${this.dependencies.translateFn(
      'Additional company details'
    )} (${this.dependencies.translateFn('Optional')})`;

    this.dom.$additionalDetailsSubtitleInfo.innerText = this.dependencies.translateFn(
      'Provide additional contact information, and logos for customizing GravityZone Control Center'
    );

    this.dom.$companyAddressFormField.label = this.dependencies.translateFn('Registered address');
    this.dom.$companyAddressFormField.Input.placeholder = this.dependencies.translateFn('Enter the physical address');

    this.dom.$companyPhoneFormField.label = this.dependencies.translateFn('Phone number');
    this.dom.$companyPhoneFormField.Input.placeholder = this.dependencies.translateFn(
      'Enter the international phone number'
    );

    this.dom.$logoFormField.label = this.dependencies.translateFn('Logo in Control Center');
    this.dom.$logoImg.alt = this.dependencies.translateFn('Logo in Control Center');
    this.dom.$logoHint.innerText = this.dependencies.translateFn(
      '{logoWidth}px x {logoHeight}px size, png or jpg format',
      {
        logoWidth: CompanyDetailsConstants.Logo.Width,
        logoHeight: CompanyDetailsConstants.Logo.Height,
      }
    );

    this.dom.$logoUploadButton.innerHTML = this.dependencies.translateFn('Upload logo');
    this.dom.$logoResetButton.innerHTML = this.dependencies.translateFn('Reset to default');
    this.dom.$securityTokenFormField.label = this.dependencies.translateFn('Security Token');
  }

  setContextSpecificTranslatedStrings(formContext: CompanyActionContext) {
    const redactionLearnMoreText = `<span>${htmlEncode(this.dependencies.translateFn('Learn more'))}</span>`;

    this.dom.$basicDetailsSubtitle.innerText =
      formContext === CompanyActionContext.Create
        ? this.dependencies.translateFn('Basic company details')
        : this.dependencies.translateFn('Basic details');

    // additional details
    this.dom.$additionalDetailsSubtitle.innerText =
      formContext === CompanyActionContext.Create
        ? `${this.dependencies.translateFn('Additional company details')} (${this.dependencies.translateFn(
            'Optional'
          )})`
        : this.dependencies.translateFn('Additional details');

    // management permissions
    this.dom.$managementPermissionsSubtitle.innerText =
      formContext === CompanyActionContext.Create
        ? this.dependencies.translateFn('Security management options')
        : this.dependencies.translateFn('Management permissions');

    this.dom.$managementPermissionsSubtitleInfoCompany.innerText = this.dependencies.translateFn(
      'A company that manages security in GravityZone has access to the following sections in Control Center: Network, Risk Management, Policies, Quarantine, Email Security, and Configuration.'
    );

    this.dom.$managementPermissionsSubtitleInfoPartner.innerText = this.dependencies.translateFn(
      'For Partners, the Network Inventory includes the company`s own network and the networks of their customers, recursively.'
    );

    this.dom.$manageNetworksFormField.Input.label = this.dependencies.translateFn(
      'The company manages endpoint security'
    );

    this.dom.$canBeManagedByAboveFormField.Input.label =
      formContext === CompanyActionContext.Create
        ? this.dependencies.translateFn('The company`s Partner can assist with the security management')
        : this.dependencies.translateFn('Your Bitdefender partner can assist you with security management');

    this.dom.$allowDownloadQuarantineByAboveFormField.Input.label = translateFn(
      'Your Bitdefender partner can download your quarantined files'
    );

    this.dom.$partnerHasRedactionActiveFormField.Input.label = this.dependencies.translateFn(
      'Your Bitdefender partner has redaction activated for your Email Security account.'
    );

    this.dom.$partnerHasRedactionLink.innerHTML = redactionLearnMoreText;
    this.dom.$partnerHasRedactionLink.href = LicenseConstants.InfoLinks.EmailRedactionForGravityZone;
  }

  private buildProductSwitchCustomerNoticeInfoBox(): void {
    this.dom.$partnerHasToAddProductsToSwitchToCustomerNoticeContainer.innerHTML = `
    <span>${htmlEncode(
      this.dependencies.translateFn(
        'Cannot change the company type. Customer accounts require at least one standard product.'
      )
    )}</span>`;
  }

  private buildManagedNetworksNoticeInfoBox(): void {
    this.dom.$partnerHasManagedNetworksNoticeContainer.innerHTML = `
      <span>${htmlEncode(
        this.dependencies.translateFn('Cannot change the company type. The company manages other company accounts.')
      )}</span>`;
  }

  private buildResellAddonsNoticeInfoBox(): void {
    this.dom.$partnerWillLoseResellAddonsToggleNoticeContainer.innerHTML = `
    <span>${htmlEncode(
      this.dependencies.translateFn(
        'The company will no longer be able to resell products with Monthly Subscription and to manage other company accounts in GravityZone.'
      )
    )}</span>`;
  }

  private buildMdrReportsAccessSwitchCustomerNoticeInfoBox(): void {
    this.dom.$partnerWillLoseMdrReportsAccessNoticeContainer.innerHTML = `
    <span>${translateFn('This company will no longer have access to the MDR aggregated reports.')}</span>`;
  }

  private buildPartnerResellingNoticeInfoBox(): void {
    this.dom.$customerToPartnerResellingNoticeContainer.innerHTML = `
    <span>${htmlEncode(
      this.dependencies.translateFn(
        'The company will be able to resell the products with Monthly Subscription for own use  and to manage other company accounts in GravityZone.'
      )
    )}</span>`;
  }

  private buildCompanyHasChildrenInfoBox(): void {
    this.dom.$companyHasChildrenWarningContainer.innerHTML = `
    <span>${htmlEncode(
      this.dependencies.translateFn(
        'You cannot change these permissions as long as the partner manages other companies.'
      )
    )}</span>`;
  }

  private buildCompanyHasProductsInfoBox(): void {
    this.dom.$companyHasProductsWarningContainer.innerHTML = `
    <span>${htmlEncode(
      this.dependencies.translateFn('Cannot revoke this right. The company has a GravityZone registered product.')
    )}</span>`;
  }

  public get isReadOnly() {
    // company details form is readOnly when:
    // - the root account does not have editing rights for this company
    // - the account has partial editing rights for this company,
    // but the Customization and Custom fields (which should be editable) are not available
    return (
      this.editingRight === CompanyEditingRight.None ||
      (this.editingRight === CompanyEditingRight.Partial &&
        !(this.loggedUser.role.rights.managePlatform || this.dom.$customFieldsForm.isCustomFieldsFormAvailable))
    );
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }

  buildSuccessView(viewData: CompanyDetailsFormViewData) {
    this.cacheViewData(viewData);

    this.setContextSpecificTranslatedStrings(viewData.formContext);

    this.createFormGroup();

    this.setCompanyCustomizationDropdown(viewData.formContext, viewData.loggedUser, viewData.companyCustomizations);
    this.initCompanyTypeDropdown(viewData.formContext, viewData.companyTypes);

    this.setCountryDropdownOptions(viewData.countries);
    this.setIndustryDropdownOptions(viewData.industries);
    this.setCompanyRoleDropdownOptions(viewData.companyRoles);

    this.setLanguagesDropdownOptions(viewData.languages);

    if (viewData.timezones) {
      this.setTimezonesDropdownOptions(viewData.timezones);
    }

    this.dom.$manageNetworksFormField.initialValue = true;

    this.setLogoImg(this.defaultLogoId).catch(console.error);

    this.setupSecurityPermissionsSection(viewData.formContext);
    this.setupPrimaryAccountSection(viewData.formContext, viewData.loggedUser);
    this.setupContactDetailsSection(viewData.formContext);
    this.setupMdrContactDetailsSectionMonthly();

    this.setupAdditionalDetailsSection(viewData.formContext);

    this.removeLoadingState();
  }

  buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.removeLoadingState();

    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  private getCountryPicklistValueFromCompanyData(company: CompanyData) {
    return company.specifics.country !== 'N/A' ? company.specifics.country : '';
  }

  private getIndustryPicklistValueFromCompanyData(company: CompanyData) {
    if (company.specifics.industry === 0) {
      return '';
    }
    return company.specifics.industry?.toString() || '';
  }

  private async shouldCustomFieldsBeDisplayed() {
    if (this.context !== CompanyActionContext.Edit) {
      return false;
    }

    return await this.dependencies.api.clients.CustomFields.ShouldCustomFieldsBeVisible().toPromise();
  }

  public async setCompanyData(company: CompanyData) {
    this.editingRight = CompanyEditingRight.getCompanyEditingRight(
      company.readOnly ?? false,
      company.specifics.canBeManagedByAbove,
      this.context
    );

    if (this.context === CompanyActionContext.MyCompany) {
      toggleVisibility(
        this.dom.$partnerHasRedactionActiveFormField,
        company.specifics.cloudUss.provisionStatus === CompanyDetailsConstants.CloudUss.ProvisionStatus.Done &&
          company.specifics.features.emailSecurityUsable === true
      );
    }

    this.setEditedCompanyData(company);

    if (this.context === CompanyActionContext.Edit) {
      // set the Company type if the context is Edit
      this.dom.$companyTypeFormField.Input.setFormValue(CompanyData.getCompanyType(company));
      this.setupManageNetworksToggle(this.context);
    }

    this.updateCompanyTypeDropdown(this.context);

    // company role has a text-field input if "Other" is selected in the dropdown
    const existingRole = this.companyRoles.find(companyRole => {
      return companyRole.value === company.specifics.contactPerson?.companyRole;
    });

    if (existingRole && company.specifics.contactPerson?.companyRole !== CompanyDetailsConstants.CompanyRoles.Other) {
      this.dom.$contactRoleFormField.value = company.specifics.contactPerson?.companyRole || '';
    } else {
      this.dom.$contactRoleFormField.value = CompanyDetailsConstants.CompanyRoles.Other;
      this.dom.$contactRoleOtherFormField.value = company.specifics.contactPerson?.companyRole || '';
    }

    await this.setLogoImg(company.specifics.logoFileId);
    if (!company.company) {
      this.hideManagementPermissionsSection();
    }

    if (await this.shouldCustomFieldsBeDisplayed()) {
      this.dom.$customFieldsForm.injectDependencies(this.dependencies);
      this.dom.$customFieldsForm.managedCompanyId = company._id;
      this.dom.$customFieldsForm.editingRight = this.editingRight;
      await this.dom.$customFieldsForm.start();
      toggleVisibility(this.dom.$customFieldsForm, this.dom.$customFieldsForm.isCustomFieldsFormAvailable);
    }

    // replace company name validators (to exclude the company's current name during the uniqueness check)
    this.setCompanyNameValidators(company);

    await this.setupMdrContactDetailsSection();

    this.isInit = true;
    this.formGroup.value = {
      name: company.name,
      specifics: {
        country: this.getCountryPicklistValueFromCompanyData(company),
        state: company.specifics.state,
        industry: this.getIndustryPicklistValueFromCompanyData(company),
        address: company.specifics.address ?? '',
        phone: company.specifics.phone ?? '',
        canBeManagedByAbove: company.specifics.canBeManagedByAbove,
        allowDownloadQuarantineByAbove: company.specifics.allowDownloadQuarantineByAbove ?? false,
        cloudUss: {
          redacted: company.specifics.cloudUss.redacted ?? true, // true if redacted is not set
        },
        logoFileId: company.specifics.logoFileId,
        oemKitId: company.specifics.oemKitId.toString(),
        contactPerson: {
          fullName: company.specifics.contactPerson?.fullName ?? '',
          email: company.specifics.contactPerson?.email ?? '',
          phoneNumber: company.specifics.contactPerson?.phoneNumber ?? '',
          companyRole: company.specifics.contactPerson?.companyRole ?? '',
        },
        mdrContactInformation: {
          fullName: company.specifics.mdrContactInformation?.fullName ?? '',
          email: company.specifics.mdrContactInformation?.email ?? '',
          emailVerificationCode: '',
          phoneNumber: this.extractMdrContactInformationPhoneNumberFromCompanyData(company),
          importedCompanyId: company.specifics.mdrContactInformation?.importedCompanyId ?? null,
          importedAccountId: company.specifics.mdrContactInformation?.importedAccountId ?? null,
        },
        rights: {
          manageNetworks: company.specifics.rights.manageNetworks ?? true,
        },
      },
    };

    this.formGroup.validate(true);

    this.refreshInitialValues();

    if (company.specifics.maEnforced) {
      toggleVisibility(this.dom.$securityTokenFormField, true);
      this.dom.$securityTokenFormField.value = company.specifics.maToken;
    }

    this.setFormGroupToDisabled();
  }

  private extractMdrContactInformationPhoneNumberFromCompanyData(company: CompanyData): any {
    const subscriberNumber = company.specifics.mdrContactInformation?.phoneNumber?.subscriberNumber ?? '';
    const countryCode = company.specifics.mdrContactInformation?.phoneNumber?.countryCode ?? '';

    if (this.isMdrContactSectionMonthlyAvailable()) {
      // Monthly MDR Contact Information Phone Number needs string format
      const prefix = convertCountryCodeToPrefix(
        company.specifics.mdrContactInformation?.phoneNumber?.countryCode ?? ''
      );
      return prefix + subscriberNumber;
    }

    // Yearly MDR Contact Information Phone Number needs object format
    return { countryCode, subscriberNumber };
  }

  private setFormGroupToDisabled() {
    if (this.context !== CompanyActionContext.Edit || this.editingRight === CompanyEditingRight.Full) {
      return;
    }

    this.formGroup.setDisabled(true);
    this.contactPersonFormGroup.setDisabled(true);
    this.mdrContactDetailsMonthlyFormGroup.setDisabled(true);
    this.primaryAccountProfileFormGroup.setDisabled(true);
    this.dom.$companyTypeFormField.disabled = true;
    this.dom.$logoUploadButton.disabled = true;
    this.dom.$securityTokenFormField.disabled = true;

    this.dom.$companyCustomizationFormField.disabled = this.editingRight === CompanyEditingRight.None;
  }

  public async setLogoImg(logoFileId: string) {
    // set it in the hidden input
    this.dom.$logoFileIdFormField.value = logoFileId;

    // show / hide "Reset to default" button
    this.dom.$logoResetButton.style.display = logoFileId === this.defaultLogoId ? 'none' : 'block';

    // set the src on the <img> component
    this.dom.$logoImg.src = await this.dependencies.api.clients.Company.GetLogoSrc(logoFileId).toPromise();

    // the image is hidden initially => after setting the src we can un-hide it
    this.dom.$logoImg.classList.remove('hidden');
  }

  public updateRedactionCheckboxStateByManagedByAbove() {
    const isManagedByAbove = this.dom.$canBeManagedByAboveFormField.Input.getFormValue();
    if (!isManagedByAbove) {
      this.dom.$partnerHasRedactionActiveFormField.Input.setFormValue(true);
    }
    this.dom.$partnerHasRedactionActiveFormField.Input.readonly = !isManagedByAbove;
  }

  public updatePrimaryAccountRequiredness() {
    this.setPrimaryAccountValidators();
  }

  public updateMdrContactVisibilityAndValidators() {
    this.setMdrContactFieldsMonthlyVisibilityAndValidators();
  }

  protected onDisconnect() {
    this.formGroup?.unsubscribe();

    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private cacheViewData(viewData: CompanyDetailsFormViewData) {
    this.states = viewData.states;
    this.companyRoles = viewData.companyRoles;
    this.defaultLogoId = viewData.defaultLogoId;
    this.context = viewData.formContext;
    this.loggedUser = viewData.loggedUser;
    this.rootVisibilityTree = viewData.rootVisibilityTree;
  }

  private shouldShowCustomizationDropdown(formContext: CompanyActionContext, loggedUser: User) {
    return (
      (formContext === CompanyActionContext.Create || formContext === CompanyActionContext.Edit) &&
      loggedUser.role.rights.managePlatform
    );
  }

  private setCompanyCustomizationDropdown(
    formContext: CompanyActionContext,
    loggedUser: User,
    options: CompanyCustomizationData[]
  ) {
    const isCustomizationDropdownVisible = this.shouldShowCustomizationDropdown(formContext, loggedUser);

    toggleVisibility(this.dom.$companyCustomizationFormField, isCustomizationDropdownVisible);

    this.dom.$companyCustomizationFormField.Input.options = options.map(customization => {
      return {
        title: customization.name,
        value: customization.id.toString(),
      };
    });

    if (isCustomizationDropdownVisible) {
      this.formGroup.addFormChild(['specifics', 'oemKitId'], this.dom.$companyCustomizationFormField);
    } else {
      this.formGroup.removeFormChild(['specifics', 'oemKitId']);
    }
  }

  private isCompanyTypeFormFieldVisible(formContext: CompanyActionContext) {
    return formContext === CompanyActionContext.Create || formContext === CompanyActionContext.Edit;
  }

  private isCompanyTypeEditable(formContext: CompanyActionContext, company: CompanyData): boolean {
    if (formContext === CompanyActionContext.Create) {
      return true;
    }

    if (formContext === CompanyActionContext.MyCompany) {
      return false;
    }

    const editedCompanyType = CompanyData.getCompanyType(company);
    if (editedCompanyType === CompanyType.Customer) {
      return true;
    }

    const companyHasChildren = (company.children ?? 0) > 0;

    return !(companyHasChildren || company.readOnly);
  }

  private initCompanyTypeDropdown(formContext: CompanyActionContext, options: CompanyTypeData[]) {
    const isCompanyTypeFormFieldVisible = this.isCompanyTypeFormFieldVisible(formContext);

    toggleVisibility(this.dom.$companyTypeFormField, isCompanyTypeFormFieldVisible);

    this.dom.$companyTypeFormField.Input.options = options.map(companyType => {
      return {
        title: companyType.name,
        value: companyType.value,
      };
    });
  }

  private updateCompanyTypeDropdown(formContext: CompanyActionContext) {
    toggleVisibility(this.dom.$companyTypeFormField, this.isCompanyTypeFormFieldVisible(formContext));
  }

  private setCountryDropdownOptions(countries: CountryData[]) {
    this.dom.$countryFormField.Input.options = countries.map(country => {
      return {
        title: country.countryName,
        value: country.countryCode,
      };
    });
  }

  private setIndustryDropdownOptions(industries: IndustryData[]) {
    this.dom.$industryFormField.Input.options = industries.map(industry => {
      return {
        title: industry.name,
        value: industry.value.toString(),
      };
    });
  }

  private setCompanyRoleDropdownOptions(companyRoles: CompanyRoleData[]) {
    this.dom.$contactRoleFormField.Input.options = companyRoles.map(role => {
      return {
        title: role.display,
        value: role.value,
      };
    });
  }

  private setTimezonesDropdownOptions(timezones: TimezoneData[]) {
    this.dom.$primaryAccountTimezoneFormField.Input.options = timezones.map(timezone => {
      return {
        title: timezone.value,
        value: timezone.id,
      };
    });
  }

  private setLanguagesDropdownOptions(languages: LanguageData[]) {
    this.dom.$primaryAccountLanguageFormField.Input.options = languages.map(language => {
      return {
        title: language.title,
        value: language.id,
      };
    });
  }

  private setupSecurityPermissionsSection(formContext: CompanyActionContext) {
    this.setupManageNetworksToggle(formContext);
    this.setupCanBeManagedByAboveToggle(formContext);
    this.setupAllowDownloadQuarantineByAboveToggle(formContext);
    this.setupPartnerHasRedactionActiveToggle(formContext);
  }

  private setupManageNetworksToggle(formContext: CompanyActionContext) {
    toggleVisibility(this.dom.$manageNetworksFormField, formContext !== CompanyActionContext.MyCompany);
    toggleVisibility(this.dom.$managementPermissionsSubtitleInfoCompany, formContext === CompanyActionContext.Create);
    toggleVisibility(this.dom.$managementPermissionsSubtitleInfoPartner, formContext === CompanyActionContext.Create);

    if (formContext !== CompanyActionContext.MyCompany) {
      this.formGroup.addFormChild(['specifics', 'rights', 'manageNetworks'], this.dom.$manageNetworksFormField);
    } else {
      this.formGroup.removeFormChild(['specifics', 'rights', 'manageNetworks']);
    }

    this.updateManageNetworksToggleSection();
  }

  public updateManageNetworksToggleSection(showWarnings: boolean = false): void {
    if (!(this.context === CompanyActionContext.Edit && this.editedCompanyData)) {
      return;
    }

    const companyHasChildren = (this.editedCompanyData.children ?? 0) > 0;
    const canBeManagedByAbove = this.editedCompanyData.specifics.canBeManagedByAbove ?? false;
    const companySubscription = CompanyData.determineCompanySubscription(this.editedCompanyData);

    const hasPaymentPlan = !CompanyData.hasNonePaymentPlan(this.editedCompanyData);
    const hasEndUserLicense = companySubscription === SubscriptionType.Licensed;
    const hasTrial = companySubscription === SubscriptionType.Trial;
    const hasMonthlyLicenseTrial = companySubscription === SubscriptionType.MonthlyLicenseTrial;
    const hasFratSubscription = companySubscription === SubscriptionType.Frat;
    const hasAnyLicense = hasFratSubscription || hasEndUserLicense || hasTrial || hasMonthlyLicenseTrial;

    const mustRemoveProductsToUncheckManageNetworks =
      hasPaymentPlan && hasAnyLicense && !this.dom.$manageNetworksFormField.value;

    // the option is disabled if company has children or cannot be managed by above
    this.dom.$manageNetworksFormField.readonly = companyHasChildren || !canBeManagedByAbove;

    this.dom.$manageNetworksFormField.Validators = mustRemoveProductsToUncheckManageNetworks
      ? [WhitelistValidator([true], '')]
      : [];

    if (!showWarnings) {
      return;
    }

    if (mustRemoveProductsToUncheckManageNetworks) {
      toggleVisibility(this.dom.$companyHasProductsWarningContainer, true);
      return;
    }

    if (companyHasChildren && canBeManagedByAbove && this.dom.$manageNetworksFormField.readonly) {
      toggleVisibility(this.dom.$companyHasChildrenWarningContainer, true);
      return;
    }

    toggleVisibility(this.dom.$companyHasProductsWarningContainer, false);
    toggleVisibility(this.dom.$companyHasChildrenWarningContainer, false);
  }

  public setCompanyTypeValidator(canBeCustomer: boolean = true) {
    if (!canBeCustomer) {
      // when editing a company, you cannot always switch from partner to customer
      this.dom.$companyTypeFormField.Validators = [
        RequiredValidator(this.commonStrings.requiredField),
        WhitelistValidator<CompanyType>([CompanyType.Partner], ''),
      ];

      return;
    }

    this.dom.$companyTypeFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      WhitelistValidator<CompanyType>(
        canBeCustomer ? CompanyType.GetAllTypes() : [CompanyType.Partner],
        this.dependencies.translateFn('Enter a valid company type')
      ),
    ];
  }

  public setCanBeManagedByAbove(canBeManagedByAbove: boolean): void {
    this.dom.$canBeManagedByAboveFormField.value = canBeManagedByAbove;
  }

  private setupCanBeManagedByAboveToggle(formContext: CompanyActionContext) {
    const isManagedByAboveVisible =
      formContext === CompanyActionContext.Create || formContext === CompanyActionContext.MyCompany;
    this.dom.$canBeManagedByAboveFormField.initialValue = isManagedByAboveVisible;

    toggleVisibility(this.dom.$canBeManagedByAboveFormField, isManagedByAboveVisible);

    if (isManagedByAboveVisible) {
      this.formGroup.addFormChild(
        ['specifics', 'rights', 'canBeManagedByAbove'],
        this.dom.$canBeManagedByAboveFormField
      );
    } else {
      this.formGroup.removeFormChild(['specifics', 'rights', 'canBeManagedByAbove']);
    }
  }

  private setupAllowDownloadQuarantineByAboveToggle(formContext: CompanyActionContext): void {
    this.dom.$allowDownloadQuarantineByAboveFormField.initialValue = false;
    toggleVisibility(
      this.dom.$allowDownloadQuarantineByAboveFormField,
      QuarantineActionEnabler.userHasDownloadQuarantineRights() && formContext === CompanyActionContext.MyCompany
    );
  }

  private setupPartnerHasRedactionActiveToggle(formContext: CompanyActionContext) {
    const isPartnerRedactionVisible = formContext === CompanyActionContext.MyCompany;

    toggleVisibility(this.dom.$partnerHasRedactionActiveFormField, isPartnerRedactionVisible);

    if (isPartnerRedactionVisible) {
      this.formGroup.addFormChild(['specifics', 'cloudUss', 'redacted'], this.dom.$partnerHasRedactionActiveFormField);
    } else {
      this.formGroup.removeFormChild(['specifics', 'cloudUss', 'redacted']);
    }
  }

  private setupPrimaryAccountSection(formContext: CompanyActionContext, loggedUser: User) {
    toggleVisibility(this.dom.$primaryAccountFormSection, formContext === CompanyActionContext.Create);
    toggleVisibility(this.dom.$primaryAccountSubtitle, formContext === CompanyActionContext.Create);
    toggleVisibility(this.dom.$primaryAccountSubtitleInfo, formContext === CompanyActionContext.Create);
    toggleVisibility(this.dom.$primaryAccountSubtitleDescription, formContext === CompanyActionContext.Create);

    // default to the logged-user's timezone/language (this is at build-time, so setCompanyData can overwrite this later)
    this.dom.$primaryAccountTimezoneFormField.value = loggedUser.profile.timezone;
    this.dom.$primaryAccountLanguageFormField.value = loggedUser.profile.language;

    if (formContext === CompanyActionContext.Create) {
      this.formGroup.addFormChild(['email'], this.dom.$primaryAccountEmailFormField);
      this.formGroup.addFormChild(['profile'], this.primaryAccountProfileFormGroup);

      this.subscriptions.push(
        this.dom.$primaryAccountEmailFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.updatePrimaryAccountRequiredness();
          },
        })
      );

      this.subscriptions.push(
        this.dom.$primaryAccountFullNameFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.updatePrimaryAccountRequiredness();
          },
        })
      );
    } else {
      this.formGroup.removeFormChild(['email']);
      this.formGroup.removeFormChild(['profile']);
    }
  }

  private isContactDetailsSectionAvailable(formContext: CompanyActionContext) {
    return formContext !== CompanyActionContext.Create && formContext !== CompanyActionContext.Edit;
  }

  private setupContactDetailsSection(formContext: CompanyActionContext) {
    const isContactDetailsSectionAvailable = this.isContactDetailsSectionAvailable(formContext);

    toggleVisibility(this.dom.$contactDetailsSubtitle, isContactDetailsSectionAvailable);
    toggleVisibility(this.dom.$contactDetailsFormSection, isContactDetailsSectionAvailable);

    if (!isContactDetailsSectionAvailable) {
      this.formGroup.removeFormChild(['specifics', 'contactPerson']);
    } else {
      this.formGroup.addFormChild(['specifics', 'contactPerson'], this.contactPersonFormGroup);
    }
  }

  public addFormChildMdrContactInformationYearly(): void {
    // Add mdrContactInformation for Yearly (or overwrite for MSP, if existent)
    this.formGroup.addFormChild(
      ['specifics', 'mdrContactInformation'],
      this.dom.$mdrContactDetailsSectionYearly.getFormGroup()
    );
  }

  public async setupMdrContactDetailsSection(): Promise<void> {
    this.setupFullMdrContactDetailsSectionMonthly();
    await this.setupMdrContactDetailsSectionYearly();
  }

  private async setupMdrContactDetailsSectionYearly(): Promise<void> {
    const isAvailable = this.isMdrContactSectionYearlyAvailable();
    const isStarted = this.dom.$mdrContactDetailsSectionYearly.started;

    if (!isStarted && !isAvailable) {
      return;
    }

    if (!isStarted && isAvailable) {
      await this.startMdrContactDetailsSectionYearly();
      return;
    }

    if (isStarted && isAvailable) {
      this.updateMdrContactDetailsSectionYearly();
      return;
    }

    // isStarted && !isAvailable
    await this.stopMdrContactDetailsSectionYearly();
  }

  private isMdrContactSectionYearlyAvailable() {
    if (this.context === CompanyActionContext.Create) {
      return false;
    }

    if (!this.editedCompanyData) {
      return false;
    }

    const isPartner = this.isPartnerView();
    const canBeManagedByRoot = this.editedCompanyData.visibilityTree === this.rootVisibilityTree;
    const hasNoLicense = CompanyData.hasNonePaymentPlan(this.editedCompanyData);
    const hasYearly = CompanyData.hasYearlyPaymentPlan(this.editedCompanyData);
    const isRelevantPartner = isPartner && canBeManagedByRoot && (hasNoLicense || hasYearly);
    const hasMdr = CompanyData.hasMdrLicense(this.editedCompanyData);
    const isCustomerWithMdrYearly = !isPartner && hasMdr && hasYearly;

    return isRelevantPartner || isCustomerWithMdrYearly;
  }

  private isPartnerView(): boolean {
    if (!this.editedCompanyData || this.context === CompanyActionContext.Edit) {
      // On Create/Edit, use $companyTypeFormField's value to reflect changes when dropdown option is changed too, not only at company SAVE
      return this.dom.$companyTypeFormField.value === CompanyType.Partner;
    }

    // On MyCompany, use the real database value
    return CompanyData.getCompanyType(this.editedCompanyData) === CompanyType.Partner;
  }

  private async startMdrContactDetailsSectionYearly(): Promise<void> {
    const mdrSectionYearly = this.dom.$mdrContactDetailsSectionYearly;

    toggleVisibility(mdrSectionYearly, true);

    // Prevent re-rendering when mdrSectionYearly.viewData changes its value. Must render only at start() call!
    mdrSectionYearly.propertiesSet = false;
    this.setMdrContactDetailsYearlyViewData();

    mdrSectionYearly.injectDependencies(this.dependencies);
    await mdrSectionYearly.start();
  }

  public updateMdrContactDetailsSectionYearly(): void {
    // Set data-view-data attribute of the component, and let attributeChangedCallback() do the rendering
    this.setMdrContactDetailsYearlyViewData();
    this.dom.$mdrContactDetailsSectionYearly.propertiesSet = true;
  }

  private async stopMdrContactDetailsSectionYearly(): Promise<void> {
    toggleVisibility(this.dom.$mdrContactDetailsSectionYearly, false);

    await this.dom.$mdrContactDetailsSectionYearly.stop();

    if (this.isMdrContactSectionMonthlyAvailable()) {
      // Overwrite with the Monthly form version
      this.formGroup.addFormChild(['specifics', 'mdrContactInformation'], this.mdrContactDetailsMonthlyFormGroup);
    } else {
      // Remove it altogether
      this.formGroup.removeFormChild(['specifics', 'mdrContactInformation']);
    }
  }

  private setMdrContactDetailsYearlyViewData(): void {
    if (!this.editedCompanyData) {
      return;
    }

    const company = this.editedCompanyData;
    const info = this.editedCompanyData.specifics.mdrContactInformation;

    const infoImportOptions = {
      ...(info?.importedCompanyId ? { importedCompanyId: info.importedCompanyId } : {}),
      ...(info?.importedAccountId ? { importedAccountId: info.importedAccountId } : {}),
    } as MdrContactImportSourceValue;

    this.dom.$mdrContactDetailsSectionYearly.viewData = {
      ...infoImportOptions,
      fullName: info?.fullName ?? '',
      email: info?.email ?? '',
      phoneNumber: info?.phoneNumber ?? {
        countryCode: '',
        subscriberNumber: '',
      },
      context: this.context,
      isInPopUp: false,
      editedCompanyId: company._id,
      canBeManagedByCurrentUser: this.dependencies.getUser().visibilityTree === company.visibilityTree,
      required: this.isMdrContactSectionYearlyRequired(company),
      isPartner: this.isPartnerView(),
    };
  }

  private isMdrContactSectionYearlyRequired(company: CompanyData): boolean {
    if (!this.isPartnerView()) {
      return true;
    }

    const mdrContactInfo = company.specifics.mdrContactInformation;

    if (!mdrContactInfo || isEmpty(mdrContactInfo)) {
      return false;
    }

    const { fullName, email, phoneNumber } = mdrContactInfo;
    const { countryCode, subscriberNumber } = phoneNumber ?? { countryCode: '', subscriberNumber: '' };

    // If any form field was already filled before, then it is mandatory to fill the entire MDR Contact Details form
    return !isEmpty(fullName) || !isEmpty(email) || !isEmpty(countryCode) || !isEmpty(subscriberNumber);
  }

  private isMdrContactSectionMonthlyAvailable() {
    if (this.context !== CompanyActionContext.Edit && this.context !== CompanyActionContext.MyCompany) {
      return false;
    }

    if (!this.editedCompanyData) {
      return false;
    }

    const hasMdrResell = this.editedCompanyData.specifics.features.mdrAdviceDelegate ?? false;
    const hasMonthlySubscription = CompanyData.hasMonthlySubscription(this.editedCompanyData);
    const isPartner = this.isPartnerView();

    return hasMdrResell && hasMonthlySubscription && isPartner;
  }

  private isMdrContactSectionLocked() {
    return (
      CompanyData.getMdrManagerStatus(this.editedCompanyData) !== null ||
      CompanyData.isMdrContactFilled(this.editedCompanyData)
    );
  }

  private setupMdrContactDetailsSectionMonthly() {
    const isAvailable = this.isMdrContactSectionMonthlyAvailable();
    const isLocked = this.isMdrContactSectionLocked();

    toggleVisibility(this.dom.$mdrContactDetailsSubtitle, isAvailable);
    toggleVisibility(this.dom.$mdrContactDetailsFormSection, isAvailable);
    toggleVisibility(this.dom.$mdrContactDetailsEmailVerificationCodeFormField, !isLocked);
    toggleVisibility(this.dom.$mdrContactDetailsImportFromGeneralInfoButton, !isLocked);
    toggleVisibility(this.dom.$mdrContactDetailsImportFromGeneralInfoNotice, !isLocked);
    toggleVisibility(this.dom.$mdrContactDetailsEmailVerificationNotice, !isLocked);
    toggleVisibility(this.dom.$mdrContactDetailsVerifyEmailButton, !isLocked);

    this.dom.$mdrContactDetailsFullNameFormField.readonly = isLocked;
    this.dom.$mdrContactDetailsEmailFormField.readonly = isLocked;
    this.dom.$mdrContactDetailsPhoneFormField.readonly = isLocked;

    if (!isLocked) {
      this.dom.$mdrContactDetailsEmailFormField.valid$.subscribe({
        next: emailIsValid => {
          const empty = this.dom.$mdrContactDetailsEmailFormField.value === '';
          this.dom.$mdrContactDetailsVerifyEmailButton.disabled = !emailIsValid || empty;
        },
      });

      this.subscriptions.push(
        this.dom.$mdrContactDetailsFullNameFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.updateMdrContactVisibilityAndValidators();
          },
        })
      );

      this.subscriptions.push(
        this.dom.$mdrContactDetailsEmailFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.updateMdrContactVisibilityAndValidators();
          },
        })
      );

      this.subscriptions.push(
        this.dom.$mdrContactDetailsPhoneFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.updateMdrContactVisibilityAndValidators();
          },
        })
      );

      this.subscriptions.push(
        this.dom.$mdrContactDetailsEmailVerificationCodeFormField.value$
          .pipe(debounceTime(250), distinctUntilChanged())
          .subscribe({
            next: () => {
              this.updateMdrContactVisibilityAndValidators();
            },
          })
      );

      this.subscriptions.push(
        this.dom.$contactFullNameFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.toggleImportMdrContactMonthlyInfoButton();
          },
        })
      );

      this.subscriptions.push(
        this.dom.$mdrContactDetailsEmailFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.toggleImportMdrContactMonthlyInfoButton();
          },
        })
      );

      this.subscriptions.push(
        this.dom.$mdrContactDetailsPhoneFormField.value$.pipe(debounceTime(250), distinctUntilChanged()).subscribe({
          next: () => {
            this.toggleImportMdrContactMonthlyInfoButton();
          },
        })
      );
    } else {
      this.dom.$mdrContactDetailsCannotChangeNotice.innerText = this.dependencies.translateFn(
        'This information cannot be changed from GravityZone.'
      );
    }

    if (isAvailable) {
      this.formGroup.addFormChild(['specifics', 'mdrContactInformation'], this.mdrContactDetailsMonthlyFormGroup);
    } else {
      this.formGroup.removeFormChild(['specifics', 'mdrContactInformation']);
    }
  }

  private setupAdditionalDetailsSection(formContext: CompanyActionContext) {
    toggleVisibility(this.dom.$additionalDetailsSubtitleInfo, formContext === CompanyActionContext.Create);
  }

  private createFormGroup() {
    // no company data set in form initially
    this.setCompanyNameValidators(null);

    this.setCompanyTypeValidator();

    this.dom.$companyCustomizationFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];

    this.dom.$countryFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];

    this.dom.$stateFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];

    this.dom.$industryFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];

    this.dom.$companyAddressFormField.Validators = [
      MaxLengthValidator(
        CompanyDetailsConstants.Address.MaxLength,
        this.dependencies.translateFn('The address must have maximum {addressMaxLength} characters', {
          addressMaxLength: CompanyDetailsConstants.Address.MaxLength,
        })
      ),
    ];

    this.dom.$companyPhoneFormField.Validators = [
      MaxLengthValidator(
        CompanyDetailsConstants.PhoneNumber.MaxLength,
        this.dependencies.translateFn('The phone number must have maximum {phoneMaxLength} characters', {
          phoneMaxLength: CompanyDetailsConstants.PhoneNumber.MaxLength,
        })
      ),
    ];

    this.dom.$contactFullNameFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      RegexValidator(
        /^[^\s<>][^<>]*$/,
        this.dependencies.translateFn(
          'Full name cannot start with whitespace and must not contain angle brackets (< or >)'
        )
      ),
      MaxLengthValidator(
        CompanyDetailsConstants.ContactFullName.MaxLength,
        this.dependencies.translateFn('Full name must have maximum {fullNameMaxLength} characters', {
          fullNameMaxLength: CompanyDetailsConstants.ContactFullName.MaxLength,
        })
      ),
    ];

    this.dom.$contactEmailFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      EmailValidator(this.dependencies.translateFn('Enter a valid email address')),
    ];

    this.dom.$contactRoleFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];

    this.dom.$contactRoleOtherFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MaxLengthValidator(
        CompanyDetailsConstants.CompanyRoles.MaxLength,
        this.dependencies.translateFn('The position must have maximum {roleMaxLength} characters', {
          roleMaxLength: CompanyDetailsConstants.CompanyRoles.MaxLength,
        })
      ),
    ];

    this.dom.$contactPhoneFormField.Validators = [
      MaxLengthValidator(
        CompanyDetailsConstants.PhoneNumber.MaxLength,
        this.dependencies.translateFn('The phone number must have maximum {phoneMaxLength} characters', {
          phoneMaxLength: CompanyDetailsConstants.PhoneNumber.MaxLength,
        })
      ),
    ];

    this.setMdrContactFieldsMonthlyVisibilityAndValidators();
    this.setPrimaryAccountValidators();

    // create FormGroups
    this.formGroup = FormGroup.build({
      name: this.dom.$companyNameFormField,
      specifics: {
        country: this.dom.$countryFormField,
        industry: this.dom.$industryFormField,
        address: this.dom.$companyAddressFormField,
        phone: this.dom.$companyPhoneFormField,
        canBeManagedByAbove: this.dom.$canBeManagedByAboveFormField,
        allowDownloadQuarantineByAbove: this.dom.$allowDownloadQuarantineByAboveFormField,
        cloudUss: {
          redacted: this.dom.$partnerHasRedactionActiveFormField,
        },
        logoFileId: this.dom.$logoFileIdFormField,
      },
    });

    this.contactPersonFormGroup = FormGroup.build({
      fullName: this.dom.$contactFullNameFormField,
      email: this.dom.$contactEmailFormField,
      phoneNumber: this.dom.$contactPhoneFormField,
      companyRole: this.dom.$contactRoleFormField,
    });

    this.mdrContactDetailsMonthlyFormGroup = FormGroup.build({
      fullName: this.dom.$mdrContactDetailsFullNameFormField,
      email: this.dom.$mdrContactDetailsEmailFormField,
      emailVerificationCode: this.dom.$mdrContactDetailsEmailVerificationCodeFormField,
      phoneNumber: this.dom.$mdrContactDetailsPhoneFormField,
    });

    this.primaryAccountProfileFormGroup = FormGroup.build({
      fullName: this.dom.$primaryAccountFullNameFormField,
      timezone: this.dom.$primaryAccountTimezoneFormField,
      language: this.dom.$primaryAccountLanguageFormField,
    });
  }

  private setCompanyNameValidators(company: CompanyData | null) {
    this.dom.$companyNameFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MinLengthValidator(
        CompanyDetailsConstants.CompanyName.MinLength,
        this.dependencies.translateFn('The name must have minimum {companyNameMinLength} characters', {
          companyNameMinLength: CompanyDetailsConstants.CompanyName.MinLength,
        })
      ),
      MaxLengthValidator(
        CompanyDetailsConstants.CompanyName.MaxLength,
        this.dependencies.translateFn('The name must have maximum {companyNameMaxLength} characters', {
          companyNameMaxLength: CompanyDetailsConstants.CompanyName.MaxLength,
        })
      ),
      RemoteValidator(
        (value: string) => this.dependencies.api.clients.Company.CheckNameIsUnique(value, company?._id || null),
        (response: { success: boolean }) => response.success,
        this.dependencies.translateFn('Company name already exists'),
        this.dependencies.translateFn('A communication error has occurred. Please enter the company name again')
      ),
    ];
  }

  private toggleImportMdrContactMonthlyInfoButton() {
    if (this.context === CompanyActionContext.Edit && this.editedCompanyData) {
      const anyContactSet =
        !!this.editedCompanyData.specifics.contactPerson?.fullName ||
        !!this.editedCompanyData.specifics.contactPerson?.email ||
        !!this.editedCompanyData.specifics.contactPerson?.phoneNumber;

      this.dom.$mdrContactDetailsImportFromGeneralInfoButton.disabled = !anyContactSet;
    }

    if (this.context === CompanyActionContext.MyCompany) {
      const anyContactSet =
        !!this.dom.$contactFullNameFormField.value ||
        !!this.dom.$mdrContactDetailsEmailFormField.value ||
        !!this.dom.$mdrContactDetailsPhoneFormField.value;

      this.dom.$mdrContactDetailsImportFromGeneralInfoButton.disabled = !anyContactSet;
    }
  }

  private setMdrContactFieldsMonthlyVisibilityAndValidators() {
    const isAvailable = this.isMdrContactSectionMonthlyAvailable();
    const isLocked = this.isMdrContactSectionLocked();
    if (!isAvailable || isLocked) {
      return;
    }

    const required =
      !!this.dom.$mdrContactDetailsFullNameFormField.value ||
      !!this.dom.$mdrContactDetailsEmailFormField.value ||
      !!this.dom.$mdrContactDetailsEmailVerificationCodeFormField.value ||
      !!this.dom.$mdrContactDetailsPhoneFormField.value;

    const wasRequired = this.dom.$mdrContactDetailsFullNameFormField.required === true;
    if (wasRequired === required) {
      // state hasn't changed
      return;
    }

    const fullNameValidators: FormValidator[] = [
      RegexValidator(
        /^[^\s<>][^<>]*$/,
        this.dependencies.translateFn(
          'Full name cannot start with whitespace and must not contain angle brackets (< or >)'
        )
      ),
      MaxLengthValidator(
        CompanyDetailsConstants.ContactFullName.MaxLength,
        this.dependencies.translateFn('Full name must have maximum {fullNameMaxLength} characters', {
          fullNameMaxLength: CompanyDetailsConstants.ContactFullName.MaxLength,
        })
      ),
    ];
    const emailValidators: FormValidator[] = [
      EmailValidator(this.dependencies.translateFn('Enter a valid email address')),
      RemoteValidator(
        (value: string) => {
          const companyId = this.editedCompanyData?._id ?? null;
          return this.dependencies.api.clients.Company.IsEmailValidForMdrContact(value, companyId);
        },
        (response: { success: boolean }) => response.success,
        this.dependencies.translateFn('This email address is already in use.'),
        this.dependencies.translateFn('A communication error has occurred. Please enter the email again')
      ),
    ];
    const emailVerificationCodeValidators: FormValidator[] = [
      RemoteValidator(
        (value: string) => {
          const email = this.dom.$mdrContactDetailsEmailFormField.value;
          return this.dependencies.api.clients.EmailVerification.Check(email, value);
        },
        (response: { success: boolean }) => response.success,
        this.dependencies.translateFn('Verification code does not match the one sent via email.'),
        this.dependencies.translateFn('A communication error has occurred. Please enter the email again')
      ),
    ];
    const phoneValidators: FormValidator[] = [
      MaxLengthValidator(
        CompanyDetailsConstants.PhoneNumber.MaxLength,
        this.dependencies.translateFn('The phone number must have maximum {phoneMaxLength} characters', {
          phoneMaxLength: CompanyDetailsConstants.PhoneNumber.MaxLength,
        })
      ),
    ];

    if (required) {
      fullNameValidators.push(RequiredValidator(this.commonStrings.requiredField));
      emailValidators.push(RequiredValidator(this.commonStrings.requiredField));
      emailVerificationCodeValidators.push(RequiredValidator(this.commonStrings.requiredField));
      phoneValidators.push(RequiredValidator(this.commonStrings.requiredField));
    }

    this.dom.$mdrContactDetailsFullNameFormField.required = required;
    this.dom.$mdrContactDetailsEmailFormField.required = required;
    this.dom.$mdrContactDetailsPhoneFormField.required = required;

    this.dom.$mdrContactDetailsFullNameFormField.Validators = fullNameValidators;
    this.dom.$mdrContactDetailsEmailFormField.Validators = emailValidators;
    this.dom.$mdrContactDetailsEmailVerificationCodeFormField.Validators = emailVerificationCodeValidators;
    this.dom.$mdrContactDetailsPhoneFormField.Validators = phoneValidators;
  }

  private setPrimaryAccountValidators() {
    // is required if can-be-managed-by-above is unchecked or user is filling in primary account details
    const required =
      !this.dom.$canBeManagedByAboveFormField.value ||
      !!this.dom.$primaryAccountFullNameFormField.value ||
      !!this.dom.$primaryAccountEmailFormField.value;

    const fullNameValidators = [
      MaxLengthValidator(
        CompanyDetailsConstants.ContactFullName.MaxLength,
        this.dependencies.translateFn('Full name must have maximum {fullNameMaxLength} characters', {
          fullNameMaxLength: CompanyDetailsConstants.ContactFullName.MaxLength,
        })
      ),
      RegexValidator(
        /^[\p{L}0-9]/u,
        this.dependencies.translateFn('Full name cannot begin with whitespace or any special characters')
      ),
      RegexValidator(
        /^[\p{L}0-9]+([\s@!#$%&'*+\-.\/\\\p{L}0-9])*$/u,
        this.dependencies.translateFn(
          'Full name can contain only alphanumeric characters and the following symbols: {allowedCharacters}',
          {
            allowedCharacters: "@!#$%&'*+-./\\",
            interpolation: {
              escapeValue: false,
            },
          }
        )
      ),
    ];

    const emailValidators = [
      EmailValidator(this.dependencies.translateFn('Enter a valid email address')),
      RemoteValidator(
        (value: string) => this.dependencies.api.clients.Users.IsEmailValid(value),
        (response: { success: boolean }) => response.success,
        this.dependencies.translateFn('This email address was already used'),
        this.dependencies.translateFn('A communication error has occurred. Please enter the email again')
      ),
    ];

    if (required) {
      fullNameValidators.push(RequiredValidator(this.commonStrings.requiredField));
      emailValidators.push(RequiredValidator(this.commonStrings.requiredField));
    }

    this.dom.$primaryAccountFullNameFormField.Validators = fullNameValidators;
    this.dom.$primaryAccountEmailFormField.Validators = emailValidators;

    // for the UI-part of 'required' (the asterisk)
    this.dom.$primaryAccountFullNameFormField.required = required;
    this.dom.$primaryAccountEmailFormField.required = required;

    this.dom.$primaryAccountSubtitle.innerText = required
      ? this.dependencies.translateFn('Primary account')
      : `${this.dependencies.translateFn('Primary account')} (${this.dependencies.translateFn('Optional')})`;
  }

  private hideManagementPermissionsSection() {
    toggleVisibility(this.dom.$managementPermissionsFormSection, false);
    toggleVisibility(this.dom.$managementPermissionsSubtitle, false);
  }

  public refreshInitialValues() {
    this.formGroup?.refreshInitialFormValue();
    this.dom.$companyTypeFormField?.refreshInitialFormValue();
    this.dom?.$customFieldsForm?.refreshInitialFormValues();

    if (this.dom.$mdrContactDetailsSectionYearly.started) {
      this.dom.$mdrContactDetailsSectionYearly.refreshInitialFormValue();
    }
  }

  public setEditedCompanyData(company: CompanyData) {
    if (this.context === CompanyActionContext.Edit || this.context === CompanyActionContext.MyCompany) {
      this.editedCompanyData = company;
    }
  }

  private setupFullMdrContactDetailsSectionMonthly(): void {
    this.setupMdrContactDetailsSectionMonthly();
    this.setMdrContactFieldsMonthlyVisibilityAndValidators();
    this.toggleImportMdrContactMonthlyInfoButton();
  }

  public discardFormChanges() {
    // Discard changes to main form
    this.formGroup.discardChanges();

    // Discard changes for fields that are not in the form
    this.dom.$companyTypeFormField.discardChanges();

    // Discard changes for custom fields form
    if (this.dom.$customFieldsForm.isCustomFieldsFormAvailable) {
      this.dom.$customFieldsForm.discardFormChanges();
    }

    // Reset logo preview to default
    const initialLogo = this.editedCompanyData?.specifics.logoFileId ?? this.defaultLogoId;
    this.setLogoImg(initialLogo).catch(console.error);

    // Reset warnings to visibility false -- no warning should be displayed in initial state
    this.resetWarnings();

    // Discard changes to MDR Contact Details. Reset to data saved in this.editedCompanyData
    if (this.dom.$mdrContactDetailsSectionYearly.started) {
      this.updateMdrContactDetailsSectionYearly();
    }
  }

  public resetWarnings() {
    toggleVisibility(this.dom.$partnerHasToAddProductsToSwitchToCustomerNoticeContainer, false);
    toggleVisibility(this.dom.$partnerHasManagedNetworksNoticeContainer, false);
    toggleVisibility(this.dom.$partnerWillLoseResellAddonsToggleNoticeContainer, false);
    toggleVisibility(this.dom.$partnerWillLoseMdrReportsAccessNoticeContainer, false);
    toggleVisibility(this.dom.$customerToPartnerResellingNoticeContainer, false);
    toggleVisibility(this.dom.$companyHasProductsWarningContainer, false);
  }

  public importMdrContactDetailsFromGeneralInfo() {
    if (!this.editedCompanyData) {
      return;
    }

    if (this.context === CompanyActionContext.Edit) {
      const contactPerson = this.editedCompanyData.specifics.contactPerson ?? {};
      this.dom.$mdrContactDetailsFullNameFormField.value = contactPerson.fullName ?? '';
      this.dom.$mdrContactDetailsEmailFormField.value = contactPerson?.email ?? '';
      this.dom.$mdrContactDetailsPhoneFormField.value = contactPerson?.phoneNumber ?? '';
    }

    if (this.context === CompanyActionContext.MyCompany) {
      this.dom.$mdrContactDetailsFullNameFormField.value = this.dom.$contactFullNameFormField.value ?? '';
      this.dom.$mdrContactDetailsEmailFormField.value = this.dom.$contactEmailFormField?.value ?? '';
      this.dom.$mdrContactDetailsPhoneFormField.value = this.dom.$contactPhoneFormField?.value ?? '';
    }
  }
}
